class ScheduleJobMatchItemActionsModalController {
    constructor() {
        // this.actionType = this.resolve.actionType;
        // this.actionLabel = this.resolve.actionLabel;
    }
    $onInit() {
        this.actionType = this.resolve.actionType;
        this.actionLabel = this.resolve.actionLabel;
        this.callbackObject = { callbackType: 'cancel', entity: {} };
    }
    closeModal() {
        this.modalInstance.close(this.callbackObject);
    }
    dismissModal() {
        this.modalInstance.dismiss('cancel');
    }
    onEmployeeAdded(employee) {
        if (employee) {
            this.callbackObject.callbackType = this.actionType;
            this.callbackObject.entity = employee;
            this.closeModal();
        }
        else {
            this.dismissModal();
        }
    }
}
// import * as TEMPLATE from './schedule-job-match-item-actions-modal.html;
import * as TEMPLATE from 'raw-loader!./schedule-job-match-item-actions-modal.html';
export const ScheduleJobMatchItemActionsModalComponent = {
    selector: 'scheduleJobMatchItemActionsModal',
    component: {
        bindings: {
            modalInstance: "<",
            resolve: "<"
        },
        controller: ScheduleJobMatchItemActionsModalController,
        template: TEMPLATE.default
        // templateUrl: 'app/shared/jobMatchActions/scheduleJobMatchItem/scheduleJobMatchItemActionsModal/schedule-job-match-item-actions-modal.html'
    }
};
//# sourceMappingURL=schedule-job-match-item-actions-modal.component.js.map